import React, { useState, useEffect } from 'react';
import { CreditCard } from 'lucide-react';
import useCredits from '../../hooks/useCredits';

/**
 * Component to display the user's credit balance
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showCount - Whether to show only the credit count without text
 * @param {boolean} props.hideIcon - Whether to hide the credit card icon
 */
const CreditsDisplay = ({ className = '', showCount = false, hideIcon = false }) => {
  const { loading, credits, error } = useCredits();
  const [displayedCredits, setDisplayedCredits] = useState(0);
  
  // Update displayed credits only after we have real data
  useEffect(() => {
    if (!loading && !error) {
      setDisplayedCredits(credits);
    }
  }, [credits, loading, error]);

  // If there's an error, show it minimally (only in the icon color)
  if (error) {
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        {!hideIcon && <CreditCard className="w-4 h-4 text-red-500" />}
        <span className="text-sm font-medium text-[#5E60CE]">
          {showCount ? displayedCredits : `${displayedCredits} ${displayedCredits === 1 ? 'Credit' : 'Credits'}`}
        </span>
      </div>
    );
  }

  // Always display the credits, even while loading (will show previous value until new one loads)
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {!hideIcon && <CreditCard className="w-4 h-4 text-[#5E60CE]" />}
      <span className="text-sm font-medium text-[#5E60CE]">
        {showCount ? displayedCredits : `${displayedCredits} ${displayedCredits === 1 ? 'Credit' : 'Credits'}`}
      </span>
    </div>
  );
};

export default CreditsDisplay; 